import { memo } from 'react';
import { rowClassname, summaryRowClassname, lastSummaryRowClassname } from './style';
import SummaryCell from './SummaryCell';
import type { RowRendererProps } from './types';

type SharedRowRendererProps<R, SR> = Pick<RowRendererProps<R, SR>,
  | 'viewportColumns'
  | 'rowIdx'
>;

interface SummaryRowProps<R, SR> extends SharedRowRendererProps<R, SR> {
  'aria-rowindex': number;
  row: SR;
  top: number;
  lastFrozenColumnIndex: number;
  isLastSummaryRow: boolean;
}

function SummaryRow<R, SR>({
  rowIdx,
  row,
  viewportColumns,
  top,
  lastFrozenColumnIndex,
  isLastSummaryRow,
  'aria-rowindex': ariaRowIndex
}: SummaryRowProps<R, SR>) {
  const cells = [];
  for (let index = 0; index < viewportColumns.length; index++) {
    const column = viewportColumns[index];

    cells.push(
      <SummaryCell<R, SR>
        key={column.key}
        column={column}
        row={row}
      />
    );
  }

  return (
    <div
      role="row"
      aria-rowindex={ariaRowIndex}
      className={`${rowClassname} rdg-row-${rowIdx % 2 === 0 ? 'even' : 'odd'} ${summaryRowClassname} ${isLastSummaryRow ? lastSummaryRowClassname : ''}`}
      style={{ top }}
    >
      {cells}
    </div>
  );
}

export default memo(SummaryRow) as <R, SR>(props: SummaryRowProps<R, SR>) => JSX.Element;
